import { GET_ORDER } from './mutation-types';

export default {
  [GET_ORDER](state, data) {
    state.orders = data.orders;
    state.count = data.count;
    state.lastFilter = data.lastFilter;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/order/mutations.js